import { useEffect, useState } from 'react'
// import Grid from '@mui/material/Grid';
import { CacheProvider } from '@emotion/react';
// import Breadcrumbs from '@mui/material/Breadcrumbs';
// import Link from '@mui/material/Link';
import { getEndpoint, getMUICache, getUrl, setCmsSeoData, fetchAnchorValue } from './../../common/utils';
import './breadCrumbs.css';
import bcrypt from 'bcryptjs-react';

BreadCrumbsAmp.version = 1000;
Object.defineProperty(BreadCrumbsAmp, 'name', {
    writable: true,
    value: 'BreadCrumbsAmp'
});

export function BreadCrumbsAmp(props: any) {
    const [breadCrumbsData, setbreadCrumbsData] = useState<any>({});
    const { categoryName, seperator, anchorLinksValue } = props;
    const [baseCatogeryName, setbaseCatogeryName] = useState<any>("");
    const cache = getMUICache();


    let {includeTitle} = props;
    if(typeof includeTitle === 'undefined') {includeTitle = true;}

    let REQUEST_URL: any = null;
    if (props && props.REQUEST_URL) {
        REQUEST_URL = props.REQUEST_URL;
    }

    const endpoint = getEndpoint(props, "MAIN");
    useEffect(() => {
        if (!endpoint.isSSR || !endpoint.SSRDataObj) {
            fetchComponentData();
        }
    }, []);

    useEffect(() => {
        if (breadCrumbsData && Object.keys(breadCrumbsData).length > 0 && breadCrumbsData.items.length > 0) {
            let updatedData = { ...breadCrumbsData }
            updatedData.items[updatedData.items.length - 1].hl = categoryName != "" ? categoryName : baseCatogeryName;
            setbreadCrumbsData(updatedData);
        }

    }, [categoryName]);

    if (endpoint.isSSR && endpoint.SSRDataObj && endpoint.SSRDataObj.items && breadCrumbsData && Object.keys(breadCrumbsData).length === 0 && endpoint.SSRDataObj.items.length > 0) {
        setbaseCatogeryName(endpoint.SSRDataObj.items[endpoint.SSRDataObj.items.length - 1].hl)
        if (categoryName != "") {
            endpoint.SSRDataObj.items[endpoint.SSRDataObj.items.length - 1].hl = categoryName;
        }
        setbreadCrumbsData(endpoint.SSRDataObj);
        setCmsSeoData(props, JSON.parse(JSON.stringify(endpoint.SSRDataObj.items)), "BreadCrumbsAmp");
    }

    const fetchComponentData = () => {
        const breadCrumbsUrl = getUrl(props, 1, false, "MAIN", true);

        let headerString = '?' + breadCrumbsUrl.split("?")[1];
        headerString = bcrypt.hashSync(headerString, 6);
        const headers = {'p-nonce': headerString};

        fetch(breadCrumbsUrl, { headers: headers })
            .then((response) => response.json())
            .then((data) => {
                setbaseCatogeryName(data.items[data.items.length - 1].hl)
                if (categoryName != "" && data.items[0].hl != categoryName) {
                    data.items[data.items.length - 1].hl = categoryName;
                }
                setbreadCrumbsData(data);
                if(data && data.items) setCmsSeoData(props, JSON.parse(JSON.stringify(data.items)), "BreadCrumbsAmp");
            }
            )
    }

    function extractSpecificTermFromURL(url: any) {
        const topicsMatch = url.match(/\/topics\/([^\/]+)/);
        const tagsMatch = url.match(/\/tags\/([^\/]+)/);
        const authorMatch = url.match(/\/author\/([^\/]+)/);
        if (topicsMatch) {
            return 'Topics';
        } else if (tagsMatch) {
            return 'Tags';
        } else if (authorMatch) {
            return 'Author';
        }
        return null;
    }

    const getData = () => {
        if (REQUEST_URL != null && (REQUEST_URL.includes('/topics/') || REQUEST_URL.includes('/tags/') || REQUEST_URL.includes('/author/'))) {

            return [
                <a
                    // underline="hover"
                    className={""}
                    target={fetchAnchorValue(anchorLinksValue, "/")}
                    rel="noopener"
                    href={"/"}
                    color="inherit"
                >
                    {'Home'}
                </a>
                ,
                includeTitle &&
                <span className='activepage'>
                    {extractSpecificTermFromURL(REQUEST_URL)}
                </span>
            ]
        }

        const maxLengths = {
            oneBreadcrumb: 54,
            oneBreadcrumbOneTitle: 26,
            twoBreadcrumbsOneTitle: 29,
            threeBreadcrumbsOneTitle: 8,
        };

        const breadcrumbsCount = breadCrumbsData.items.length;
        const hasTitle = breadCrumbsData.title && breadCrumbsData.title !== "";

        const getMaxStringLength = () => {
            if (breadcrumbsCount === 1 && !hasTitle) {
                return maxLengths.oneBreadcrumb;
            } else if (breadcrumbsCount === 1 && hasTitle) {
                return maxLengths.oneBreadcrumbOneTitle;
            } else if (breadcrumbsCount === 2 && hasTitle) {
                return maxLengths.twoBreadcrumbsOneTitle;
            } else if (breadcrumbsCount === 3 && hasTitle) {
                return maxLengths.threeBreadcrumbsOneTitle;
            } else {
                return Infinity; // Default to no maximum length
            }
        };

        const truncateString = (inputString: any, maxLength: any) => {
            return inputString.length <= maxLength
                ? inputString
                : inputString.substring(0, maxLength) + '...';
        };

        let data = [...breadCrumbsData.items];

        return [
            data.reverse().map((item: any, index: any) => (
                <span>
                    <a
                        // underline="hover"
                        key={`${index}_${index}`}
                        className={""}
                        target={fetchAnchorValue(anchorLinksValue, item.wu === "" ? "/" : item.wu)}
                        rel="noopener"
                        href={item.wu === "" ? "/" : item.wu}
                    >
                        {truncateString(item.hl, getMaxStringLength())}
                    </a>
                    {index != data.length - 1 && <span className="seperator">{seperator}</span>}
                    {index === data.length - 1 && hasTitle && includeTitle && <span className="seperator">{seperator}</span>}
                </span>
            )),
            hasTitle && includeTitle ? (
                <span className='activepage'>
                    {truncateString(breadCrumbsData.title, getMaxStringLength())}
                </span>
            ) : null,
        ];
    };


    return (
        <div className='breadcrumbcontainer themeTwoAmpbreadcrumb'>
            <CacheProvider value={cache}>
                    <div className='breadcrumbwrapper'>
                        <div className="breadcrumb" aria-label="breadcrumb" >
                            {props.PAGE_TYPE !== undefined && props.PAGE_TYPE === 'ErrorPage' && breadCrumbsData && Object.keys(breadCrumbsData).length == 0 && getData()}
                            {breadCrumbsData && Object.keys(breadCrumbsData).length > 0 && getData()}
                        </div>
                    </div>
            </CacheProvider>
        </div>
    )

}
